
export {itemLabelFilter} from '@clayui/multi-select';
import __x__ from '@clayui/multi-select';export default __x__;